jQuery(document).ready(function ($) {
    pma_display_web_samples_page(1);
});

/**
 * Display a page of web page examples.
 * @param web_samples_page
 */
function pma_display_web_samples_page( web_samples_page = 1 ) {
    let web_samples_ajax_url = pma_block_web_samples.ajaxurl + "?action=pma_ajax_display_web_samples&web_samples_page=" + web_samples_page;
    let web_samples_loader_indicator = jQuery('#pma-web-samples-loading');

    web_samples_loader_indicator.show();

    jQuery.ajax({
        url: web_samples_ajax_url,
        method: "GET"
    })
    .done(function( html ) {
        jQuery('#pma-block-web-samples').html(html);
        pma_bind_web_sample_nav_buttons();
        web_samples_loader_indicator.hide();
    });
}

function pma_bind_web_sample_nav_buttons() {
    let event_nav_button = jQuery( "#web-sample-nav > div" );

    event_nav_button.on( 'click', function( event ) {
        event.preventDefault();
        pma_display_web_samples_page( jQuery(this).data("goto-page") );
        jQuery('html, body').animate({
            scrollTop: jQuery("#pma-block-web-samples").offset().top -100
        }, 200);
    } );
}